import { NgSelectOptionModel } from '../../../../shared/model/ng-select-option.model';
import { SiteModel } from './site.mode';

export class AssetSearchStoredInfoModel {
  customer: NgSelectOptionModel;
  site: SiteModel;
}
